import { useMutation } from '@tanstack/react-query';
import { getCommissionPreview } from '../api/commissions';
import type { CommissionPreviewRequest } from '../types';

export function useCommissionPreview() {
  return useMutation({
    mutationFn: (payload: CommissionPreviewRequest) =>
      getCommissionPreview(payload),
  });
}
